import { ProductType } from "elephant-web/gql";
import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_AMP_COLLECTION_NAME = "amp";

export const useRxCollectionAmp = (): RxCollection<Amp> | null =>
  useRxCollection<Amp>(RXDB_AMP_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Amp>>;
export type AmpQueryConstructor = UseRxData["1"];

const AMP_SCHEMA_LITERAL = {
  title: "amp schema",
  version: 2,
  description: "Represents an Amp",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    productType: {
      type: "string",
      enum: Object.values(ProductType),
    },
    title: {
      type: "string",
    },
    keywords: {
      type: "array",
      items: {
        type: "string",
      },
    },
    vmpId: {
      type: "string",
    },
  },
  required: ["id", "meta", "title", "keywords", "vmpId", "productType"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(AMP_SCHEMA_LITERAL);

export type Amp = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const AMP_SCHEMA: RxJsonSchema<Amp> = AMP_SCHEMA_LITERAL;
